// extracted by mini-css-extract-plugin
export default {"edit-profile":"EditProfile_edit-profile__yy3oP","edit-profile-details":"EditProfile_edit-profile-details__TiiDb"};